import * as _ from "lodash-es";

type Mutable<T> = { -readonly [P in keyof T]: T[P] };
export const deepCopy = <T>(obj: T): Mutable<T> => {
	if (obj == null) {
		return obj;
	}
	return _.cloneDeep(obj);
};
